import React from "react"
import { Employee } from "types/Employee"
import { Box, Typography } from "@carrotfertility/carotene-core"
import CarrotPlanForm from "components/carrotplans/CarrotPlanForm"

type CreatePlanProps = {
  employee: Employee
  inReview?: boolean
}

export function CreatePlan({ employee }: CreatePlanProps): JSX.Element {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={(theme) => theme.spacing(theme.tokens.spacing.xl)}
      justifyContent="space-around"
      alignItems="flex-start"
    >
      <Typography variant="h3">Create a new Carrot Plan</Typography>
      <CarrotPlanForm employee={employee} />
    </Box>
  )
}
